import processosMenu from './solicitacoes/menu';

// Link externo ainda não definido: enquanto estiver vazio o item aparece desabilitado.
const URL_CHECKLIST_ANEXOS = '';

const catalogoMenuItem = {
    label: 'Catálogo',
    icon: 'pi pi-fw pi-book',
    to: '/licitacoes/catalogo',
    rules: ['LICITACOES-00'],
};

const checklistAnexosMenuItem = {
    label: 'Checklist Anexos',
    icon: 'pi pi-fw pi-external-link',
    url: URL_CHECKLIST_ANEXOS,
    target: '_blank',
    disabled: !URL_CHECKLIST_ANEXOS,
    rules: ['LICITACOES-00'],
};

const menu = {
    label: 'Licitações',
    icon: 'pi pi-fw pi-briefcase',
    items: [processosMenu, catalogoMenuItem, checklistAnexosMenuItem],
    rules: ['LICITACOES-00'],
};
export default menu;
